var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52817 1.61099C9.52817 1.19677 9.19239 0.860986 8.77817 0.860986L2.02817 0.860986C1.61396 0.860986 1.27817 1.19677 1.27817 1.61099C1.27817 2.0252 1.61396 2.36099 2.02817 2.36099H8.02817V8.36099C8.02817 8.7752 8.36396 9.11099 8.77817 9.11099C9.19239 9.11099 9.52817 8.7752 9.52817 8.36099L9.52817 1.61099ZM1.53033 9.91949L9.3085 2.14132L8.24784 1.08066L0.46967 8.85883L1.53033 9.91949Z",
    fill: "#322C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightUp);
export default __webpack_public_path__ + "static/media/arrow-right-up.bc9f742396f113ffbb0f5d58c55c5e88.svg";
export { ForwardRef as ReactComponent };